import React, { useEffect, useState } from 'react';
import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const API = window.location.hostname === 'localhost'
  ? 'http://localhost:5000/api'
  : 'https://myssa1.osc-fr1.scalingo.io/api';

const Graph4 = ({ width = '100%', height = '400px' }) => {
  const [chartData, setChartData] = useState(null);

  useEffect(() => {
    fetch(`${API}/plan_expedition_cmde_client`)
      .then(response => response.json())
      .then(data => {
        const labels = data.map(item => item.Horizon);
        const ok = data.map(item => item['Préparée'] || 0);
        const enStock = data.map(item => item['En stock'] || 0);
        const manquant = data.map(item => item['Manquant'] || 0);

        setChartData({
          labels,
          datasets: [
            {
              label: 'Préparée',
              data: ok,
              backgroundColor: '#32CD32',
              stack: 'stack1',
            },
            {
              label: 'En stock',
              data: enStock,
              backgroundColor: '#90ee90',
              stack: 'stack1',
            },
            {
              label: 'Manquant',
              data: manquant,
              backgroundColor: '#ff9999',
              stack: 'stack1',
            },
          ],
        });
      })
      .catch(error => console.error('Erreur chargement PostgreSQL:', error));
  }, []);

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      title: {
        display: true,
        text: "Reste à préparer (en ligne)",
      },
      legend: {
        position: 'bottom',
      },
    },
    scales: {
      x: {
        stacked: true,
      },
      y: {
        stacked: true,
        beginAtZero: true,
      },
    },
  };

  return (
    <div style={{ width, height }}>
      {chartData ? (
        <Bar data={chartData} options={options} />
      ) : (
        <p>Chargement des données...</p>
      )}
    </div>
  );
};

export default Graph4;